import slickSlider from "../../common/slickSlider.js";

const initTestimonals = () => {
  document.querySelectorAll(".js-testimonials").forEach((el) => {
    const isDarkMode = el.closest(".is-dark-mode");
    if (isDarkMode) {
      el.classList.add("testimonials--dark-mode");
    }

    const customPaging = (slider, i) => {
      // leading zero for single digits, 01 - 99
      const maxAmount = slider.slideCount;
      // const number = `0${i + 1}`.slice(-2);

      return `${i + 1} / ${maxAmount}`;
    };

    const conf = {
      appendArrows: el.querySelector(".js-testimonials-arrows"),
      appendDots: el.querySelector(".js-testimonials-pagination-dots"),
      arrows: true,
      // dots: false,
      customPaging,
      infinite: true,
      slidesToShow: 1,
      responsive: [
        {
          breakpoint: 779,
          settings: {
            slidesToShow: 1,
            slidestoScroll: 1,
          },
        },
      ],
    };

    slickSlider(
      el.querySelector(".js-testimonial-slider"),
      conf,
      (event, slick, currentSlide) => {},
    );
  });
};

export default initTestimonals;
